import React from 'react';

import { Button } from '@ubisend/pulse-components';
import { usePulse } from '@ubisend/pulse-hooks';

const LicenseLink = ({ children, ...props }) => {
  const { platform } = usePulse();
  const { account_manager_email: link } = platform;
  const supportLink = /^(https?:\/\/)/.test(link) ? link : `mailto:${link}`;

  return (
    <Button
      as={'a'}
      variant="inline"
      target="_blank"
      href={supportLink}
      {...props}>
      {children}
    </Button>
  );
};

export default LicenseLink;
